import React, { useState } from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { Link } from "react-router";
import { Box } from "@mui/material";
import { getCaseLink, getProductData } from "@/src/services/productService";
import { useQueryClient } from "@tanstack/react-query";
import { Customer } from "@/src/types/Entities/Customer";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import { queryKeys } from "@/src/services/reactQuery/reactQueryService";

type CalendlyBookingWidgetProps = {
  responsibleParty: string;
  appointmentType: string;
  customer: Customer;
  product: AbstractCase;
  utmSource: string;
  onBookingScheduled?: () => Promise<void>;
};

const CalendlyBookingWidget = ({ responsibleParty, appointmentType, customer, product, utmSource, onBookingScheduled }: CalendlyBookingWidgetProps) => {
  const [serviceWorldButtonLoading, setServiceWorldButtonLoading] = useState(false);
  const productApiUri = getProductData(product.name, "apiUri");

  const queryClient = useQueryClient();

  useCalendlyEventListener({
    onEventScheduled: () => {
      setServiceWorldButtonLoading(true);
      setTimeout(async () => {
        await queryClient.invalidateQueries({
          queryKey: queryKeys.item(productApiUri, product.id),
        });
        await onBookingScheduled?.();
        setServiceWorldButtonLoading(false);
      }, 5000);
    },
  });

  return (
    <>
      <Box>
        <InlineWidget
          styles={{ height: "700px", width: "100%", minWidth: "0" }}
          url={`https://calendly.com/${responsibleParty}/${appointmentType}`}
          prefill={{ email: customer.email, name: customer?.person?.fullName || undefined }}
          utm={{ utmSource: utmSource }}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", margin: "1.5rem" }}>
        <ButtonLoading loadingText={"Bitte warten..."} component={Link} to={getCaseLink(product)} variant={"contained"} isLoading={serviceWorldButtonLoading}>
          Zurück zu meinem Fall
        </ButtonLoading>
      </Box>
    </>
  );
};

export default CalendlyBookingWidget;
